import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import Switch from 'react-switch';
import InputWrapper from '../atoms/InputWrapper';
import styled from 'styled-components';
import InputLabel from '../atoms/labels/InputLabel';
const StyledToggle = styled(Switch) `
    .react-switch-handle {
        box-shadow: none !important;
    }

    svg {
        display: none;
    }
`;
const ToggleItem = ({ label, onValueChange, checked = false, disabled, className }) => {
    const [checkedState, toggleChecked] = useState(checked);
    const toggleState = () => {
        toggleChecked(!checkedState);
        if (typeof onValueChange === 'function')
            onValueChange(checkedState);
    };
    return (_jsx(_Fragment, { children: _jsxs(InputWrapper, { className: className, children: [_jsx(InputLabel, { marginBottom: "5px", children: label }), _jsx(StyledToggle, { onChange: toggleState, checked: checkedState, onColor: "#FF8300", offColor: "#E6EBEE", handleDiameter: 20, disabled: disabled })] }) }));
};
export default ToggleItem;
